export const ProfilePageArabic = {
  title: 'الملف الشخصي',
  titleDesc: 'إدارة معلوماتك الشخصية',
  firstName: 'الاسم الأول',
  lastName: 'الاسم الأخير',
  email: 'البريد الإلكتروني',
  saveChanges: 'حفظ التغييرات',
  saveMessage: 'تم تحديث الاسم بنجاح',
  firstNameValidate: 'يرجى إدخال الاسم الأول',
  lastNameValidate: 'يرجى إدخال الاسم الأخير',
  emailSignature: {
    title: 'توقيع البريد الإلكتروني',
    subTitle: 'أضف توقيعًا شخصيًا لجميع الرسائل الإلكترونية المرسلة عبر نظام ATS. قم بتخصيص توقيعك أدناه.',
    placeholder: 'أضف توقيع بريدك الإلكتروني هنا'
  }
}

export const ProfilePageEnglish = {
  title: 'Profile',
  titleDesc: 'Manage your personal information',
  firstName: 'First name',
  lastName: 'Last name',
  email: 'Email',
  saveChanges: 'Save changes',
  saveMessage: 'Name updated successfully',
  firstNameValidate: 'Enter your first name',
  lastNameValidate: 'Enter your last name',
  emailSignature: {
    title: 'Email signature',
    subTitle: 'Add a personal signature to all emails sent via ATS. Customise your signature below.',
    placeholder: 'Add your email signature here'
  }
}
